import {mergeWith} from 'lodash';

export const mergeWithDefault = (values, defaultValues) => (
    mergeWith(defaultValues, values, (a, b) => b === null ? a : undefined)
);

/**
 * Show  name or first + last name of person. If null returns default
 * @param {person} person
 * @param {string} def
 * @returns {string}
 */
export const getPersonName = (person, def = '') => {
    return person ? ( person.first_name ? person.first_name + ' ' + person.last_name : person.last_name ) : def;
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/utils.js